import { productAlias } from './productAlias';

export function factoryTicketDescription(factoryTicketData: any): string {
  if(!factoryTicketData) return '';
  const order = factoryTicketData.order;
  const ids = `Factory Ticket ID: <b>${factoryTicketData._id}</b> / Order ID: <b>${order._id}</b>`;
  return `${order.customer.name}\n${productAlias(order.product)}\n${ids}`;
}
